import React from "react";

const styles = {
  error: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 50,
    width: "100%",
    backgroundColor: "#c70f0f",
    color: "white",
    fontWeight: "bold",
  },
};

const ErrorMessage = ({ message }) => {
  return <div style={styles.styles}>{message}</div>;
};

export default ErrorMessage;
